import { Link } from 'react-router-dom'
import Layout from '../layout/layout'
import { APICall } from '../utils/utils.js'
import { useState, useEffect } from 'react'
import { useParams } from "react-router-dom";

export default function ViewLead() {

    
    const [message, setMessage] = useState("");
    //const [error, setError] = useState("");
    const [lead, setLead] = useState(null);
    let { id } = useParams();

    
    useEffect(() => {
       
        if (!id || id===null) {
            id = 0;
        }
       
        var response = APICall(null, 'Leads/GetLeadById?leadId='+id, 'GET')
            .then(resposnse => {
               console.log('Data', resposnse);
                if (resposnse.StatusCode === 200) {
                    setLead(resposnse.Result);
                } else {
                    setMessage(resposnse.Message);
                    //setError(resposnse.StatusCode);
                }
                console.log('Data', lead);
            });


    }, []);

   


    return (
      <>
            <Layout>

                <div className="content-wrapper">
                    <div className="page-header">
                        <h3 className="page-title">
                            <span className="page-title-icon bg-gradient-primary text-white me-2">
                                <i className="mdi  mdi-book-open"></i>
                            </span>  Lead
                        </h3>
                        <a class="nav-link1" href="/leads"><button class="btn btn-primary btn-lg ">Back</button></a>
                    </div>

                    <div className="row">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">Details</h4>
                                <p className="card-description"> </p>

                                {lead != null && lead?.leadId>0?
                                    <form className="forms-sample">
                                        <div className="form-group row">
                                            <label for="exampleInputUsername2" className="col-sm-3 col-form-label">Name</label>
                                            <div className="col-sm-9">
                                                {lead.firstName} {lead.lastName} 
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label for="exampleInputEmail2" className="col-sm-3 col-form-label">Email</label>
                                            <div className="col-sm-9">
                                                {lead.email} 
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label for="exampleInputMobile" className="col-sm-3 col-form-label">Mobile</label>
                                            <div className="col-sm-9">
                                                {lead.phone} 
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label for="exampleInputMobile" className="col-sm-3 col-form-label">Gender</label>
                                            <div className="col-sm-9"> {lead.gender}  </div>
                                        </div>
                                        <div className="form-group row">
                                            <label for="exampleInputMobile" className="col-sm-3 col-form-label">Destination City                                          </label>
                                            <div className="col-sm-9"> {lead.destinationCity} </div>
                                        </div>

                                        <div className="form-group row">
                                            <label for="exampleInputMobile" className="col-sm-3 col-form-label">Departure City</label>
                                            <div className="col-sm-9"> {lead.departureCity} </div>
                                        </div>
                                        <div className="form-group row">
                                            <label for="exampleInputMobile" className="col-sm-3 col-form-label">Departure Date</label>
                                            <div className="col-sm-9"> {lead.departureDate} </div>
                                        </div>

                                        <div className="form-group row">
                                            <label for="exampleInputMobile" className="col-sm-3 col-form-label">Duration</label>
                                            <div className="col-sm-9"> {lead.duration} </div>
                                        </div>
                                        <div className="form-group row">
                                            <label for="exampleInputMobile" className="col-sm-3 col-form-label">Adult Number</label>
                                            <div className="col-sm-9"> {lead.adultNumber} </div>
                                        </div>
                                        <div className="form-group row">
                                            <label for="exampleInputMobile" className="col-sm-3 col-form-label">Child Number</label>
                                            <div className="col-sm-9"> {lead.childNumber} </div>
                                        </div>
                                        <div className="form-group row">
                                            <label for="exampleInputMobile" className="col-sm-3 col-form-label">Budget</label>
                                            <div className="col-sm-9"> {lead.budget} </div>
                                        </div>
                                        <div className="form-group row">
                                            <label for="exampleInputMobile" className="col-sm-3 col-form-label">Source</label>
                                            <div className="col-sm-9"> {lead.platform} </div>
                                        </div>
                                        <div className="form-group row">
                                            <label for="exampleInputMobile" className="col-sm-3 col-form-label">Assign To</label>
                                            <div className="col-sm-9"> {lead.assingedUser} </div>
                                        </div>
                                        <div className="form-group row">
                                            <label for="exampleInputMobile" className="col-sm-3 col-form-label">Country</label>
                                            <div className="col-sm-9"> {lead.country} </div>
                                        </div>

                                        <div className="form-group row">
                                            <label className="col-sm-3 col-form-label">Special Note</label>
                                            <div className="col-sm-9">
                                                {lead.specialNote} 
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label for="exampleInputMobile" className="col-sm-3 col-form-label">Status</label>
                                            <div className="col-sm-9"> {lead.leadStatus}  </div>
                                        </div>

                                        <div className="form-check form-check-flat form-check-primary">
                                            <label className="form-check-label" />
                                            {/* <button onClick={() => navigate(-1)} className="btn btn-primary btn-lg ">Back</button>*/}
                                        </div>

                                    </form>
                                    : <>
                                        <div className="form-check form-check-flat form-check-primary">
                                            <label className="form-check-label text-danger" >No record founbd! {message}</label>

                                            </div>
                                    </>
                                   

                                 } 

                            </div>
                        </div>
                    </div>

                </div>
           

            </Layout>

        </>
    )


}